import type { Translate } from "i18n/types";

export const getRiskSummaryData = (t: Translate<"prices">) => {
  return {
    memecoinUK: {
      title: t("memeCoinRiskSummaryTitle"),
      description: [
        { key: "description-1", value: t("memeCoinRiskSummaryDescription") },
        { key: "description-2", value: t("memeCoinRiskSummaryDescription2") },
        { key: "description-3", value: t("memeCoinRiskSummaryDescription3") },
        { key: "description-4", value: t("memeCoinRiskSummaryDescription4") },
        { key: "description-5", value: t("memeCoinRiskSummaryDescription5") },
        { key: "description-6", value: t("memeCoinRiskSummaryDescription6") }
      ]
    },
    stablecoinUK: {
      title: t("stableCoinRiskSummaryTitle"),
      description: [
        { key: "description-1", value: t("stableCoinRiskSummaryDescription") },
        { key: "description-2", value: t("stableCoinRiskSummaryDescription2") }
      ]
    },
    paxGoldUK: {
      title: t("commodityBackedStableCoinTitle"),
      description: [
        { key: "description-1", value: t("paxGoldDescription1") },
        { key: "description-2", value: t("paxGoldDescription2") },
        { key: "description-3", value: t("paxGoldDescription3") },
        { key: "description-4", value: t("paxGoldDescription4") }
      ]
    },
    wrappedcoinUK: {
      title: t("wrappedCoinRiskSummaryTitle"),
      description: [
        { key: "description-1", value: t("wrappedCoinRiskSummaryDescription") },
        {
          key: "description-2",
          value: t("wrappedCoinRiskSummaryDescription2")
        },
        {
          key: "description-3",
          value: t("wrappedCoinRiskSummaryDescription3")
        },
        {
          key: "description-4",
          value: t("wrappedCoinRiskSummaryDescription4")
        },
        {
          key: "description-5",
          value: t("wrappedCoinRiskSummaryDescription5")
        },
        { key: "description-6", value: t("wrappedCoinRiskSummaryDescription6") }
      ]
    },
    memecoinMiCA: {
      title: t("memeCoinRiskSummaryTitleMiCA"),
      description: [
        {
          key: "description-1",
          value: t("memeCoinRiskSummaryDescriptionMiCA")
        },
        {
          key: "description-2",
          value: t("memeCoinRiskSummaryDescription2MiCA")
        },
        {
          key: "description-3",
          value: t("memeCoinRiskSummaryDescription3MiCA")
        },
        {
          key: "description-4",
          value: t("memeCoinRiskSummaryDescription4MiCA")
        },
        {
          key: "description-5",
          value: t("memeCoinRiskSummaryDescription5MiCA")
        }
      ]
    },
    stablecoinMiCA: {
      title: t("stableCoinRiskSummaryTitleMiCA"),
      description: [
        {
          key: "description-1",
          value: t("stableCoinRiskSummaryDescriptionMiCA")
        }
      ]
    },
    paxGoldMiCA: {
      title: t("commodityBackedStableCoinTitle"),
      description: [
        { key: "description-1", value: t("paxGoldDescription1") },
        { key: "description-2", value: t("paxGoldDescription2") },
        { key: "description-3", value: t("paxGoldDescription3") },
        { key: "description-4", value: t("paxGoldDescription4") }
      ]
    },
    wrappedcoinMiCA: {
      title: t("wrappedCoinRiskSummaryTitleMiCA"),
      description: [
        {
          key: "description-1",
          value: t("wrappedCoinRiskSummaryDescriptionMiCA")
        }
      ]
    }
  };
};
